import React from 'react';
import { Card, Form, Input, Button, Switch, message } from 'antd';

const Settings = () => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log('设置保存:', values);
    message.success('设置已保存');
  };

  return (
    <div>
      <Card title="系统设置">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            autoPublish: true,
            enableAudit: false,
            notifyEnabled: true
          }}
        >
          <Form.Item
            label="自动发布开关"
            name="autoPublish"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            label="启用发布审核"
            name="enableAudit"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            label="通知提醒"
            name="notifyEnabled"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item label="抖音 App Key" name="douyinAppKey">
            <Input placeholder="请输入抖音开放平台 App Key" />
          </Form.Item>

          <Form.Item label="抖音 App Secret" name="douyinAppSecret">
            <Input.Password placeholder="请输入抖音开放平台 App Secret" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              保存设置
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Settings;
